/* ==========================================================================
   TestHelden v2 · assets/th-v2-seiten.js (Seiten: Kontakt, Suche, Warenkorb) · Stand 15.10.2026
   Portiert aus testhelden-designsystem (core.js: Formular, Zähler; commerce.js: Warenkorb; Seiten-Skripte der Prototypen
   kontakt.html, suche.html, warenkorb.html). Vanilla JS, progressive Verbesserung: jede Seite funktioniert ohne Skript
   (Formulare posten, Entfernen per Link, Kasse per Formular mit required-Checkbox). Idempotent, shopify:section:load.
   Warenkorb: Cart-AJAX (/cart/add.js, /cart/change.js, /cart/update.js) mit Section Rendering, danach Event „cart:update“
   wie th-v2.js und Philipps cart-upgrade.js, damit Header-Zähler und Drawer mitlaufen.
   ========================================================================== */
(function (window, document) {
  'use strict';
  if (window.thV2Seiten) { return; }

  var qs = function (sel, root) { return (root || document).querySelector(sel); };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduziert = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function einmal(el, key) {
    key = '__thV2s' + key;
    if (el[key]) { return false; }
    el[key] = true;
    return true;
  }
  function zahlDe(n) {
    try { return Number(n).toLocaleString('de-DE'); } catch (e) { return String(n); }
  }
  function beschreibung(el, id, an) {
    var liste = (el.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    var i = liste.indexOf(id);
    if (an && i === -1) { liste.push(id); }
    if (!an && i !== -1) { liste.splice(i, 1); }
    if (liste.length) { el.setAttribute('aria-describedby', liste.join(' ')); } else { el.removeAttribute('aria-describedby'); }
  }
  function ansagen(el, text) {
    if (!el) { return; }
    el.textContent = '';
    window.requestAnimationFrame(function () { el.textContent = text; });
  }
  function laden(btn, an) {
    if (!btn) { return; }
    btn.classList.toggle('is-loading', an);
    if (an) { btn.setAttribute('aria-busy', 'true'); } else { btn.removeAttribute('aria-busy'); }
  }

  /* ======================================================================
     Kontakt: Wahl Kunde/Organisation, Formular-Validierung, Zähler
     ====================================================================== */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function feldFehler(el, text) {
    var box = el.id ? document.getElementById(el.id + '-fehler') : null;
    var feld = el.closest('.th-field');
    var check = el.closest('.th-check');
    if (text) {
      el.setAttribute('aria-invalid', 'true');
      if (feld) { feld.classList.add('is-invalid'); }
      if (check) { check.classList.add('is-invalid'); }
      if (box) {
        var t = qs('[data-th-v2-fehler-text]', box);
        if (t) { t.textContent = text; }
        box.hidden = false;
        beschreibung(el, box.id, true);
      }
    } else {
      el.removeAttribute('aria-invalid');
      if (feld) { feld.classList.remove('is-invalid'); }
      if (check) { check.classList.remove('is-invalid'); }
      if (box) { box.hidden = true; beschreibung(el, box.id, false); }
    }
  }
  function pruefeFeld(el) {
    var name = el.getAttribute('data-th-v2-feld') || 'dieses Feld';
    var meldung = el.getAttribute('data-th-v2-meldung');
    if (el.type === 'checkbox') {
      return el.required && !el.checked ? (meldung || 'Bitte bestätigen.') : '';
    }
    var wert = (el.value || '').trim();
    if (el.required && !wert) { return meldung || ('Bitte ' + name + ' ausfüllen.'); }
    if (el.type === 'email' && wert && !EMAIL.test(wert)) { return 'Bitte eine gültige E-Mail-Adresse eingeben.'; }
    if (el.maxLength > 0 && wert.length > el.maxLength) { return 'Bitte höchstens ' + zahlDe(el.maxLength) + ' Zeichen.'; }
    return '';
  }
  function initZaehler(form) {
    qsa('[data-th-v2-zaehler]', form).forEach(function (feld) {
      var ziel = qs(feld.getAttribute('data-th-v2-zaehler'));
      if (!ziel) { return; }
      var max = feld.maxLength > 0 ? feld.maxLength : 0;
      function update() {
        var n = feld.value.length;
        ziel.textContent = zahlDe(n) + (max ? ' / ' + zahlDe(max) : '');
        ziel.classList.toggle('is-over', !!max && n > max);
      }
      feld.addEventListener('input', update);
      update();
    });
  }
  function initFormular(form) {
    if (!einmal(form, 'Form')) { return; }
    form.noValidate = true;
    initZaehler(form);
    var summary = qs('[data-th-v2-summary]', form);
    var gesendet = false;
    qsa('[data-th-v2-feld]', form).forEach(function (el) {
      var ev = el.type === 'checkbox' || el.tagName === 'SELECT' ? 'change' : 'blur';
      el.addEventListener(ev, function () {
        if (el.getAttribute('aria-invalid') === 'true' || ev === 'change') { feldFehler(el, pruefeFeld(el)); }
      });
      el.addEventListener('input', function () {
        if (el.getAttribute('aria-invalid') === 'true') { feldFehler(el, pruefeFeld(el)); }
      });
    });
    if (summary) {
      summary.addEventListener('click', function (ev) {
        var a = ev.target.closest('a[href^="#"]');
        if (!a) { return; }
        var ziel = document.getElementById(a.getAttribute('href').slice(1));
        if (ziel) { ev.preventDefault(); ziel.focus(); }
      });
    }
    form.addEventListener('submit', function (ev) {
      var falle = qs('[data-th-v2-honeypot]', form);
      if (falle && falle.value) { ev.preventDefault(); return; }
      if (gesendet) { ev.preventDefault(); return; }
      var fehler = [];
      qsa('[data-th-v2-feld]', form).forEach(function (el) {
        var text = pruefeFeld(el);
        feldFehler(el, text);
        if (text) { fehler.push({ el: el, text: text }); }
      });
      if (fehler.length) {
        ev.preventDefault();
        if (summary) {
          var titel = qs('[data-th-v2-summary-titel]', summary);
          if (titel) { titel.textContent = fehler.length === 1 ? 'Bitte prüfe 1 Feld:' : 'Bitte prüfe ' + fehler.length + ' Felder:'; }
          var ul = qs('ul', summary);
          if (ul) {
            ul.innerHTML = '';
            fehler.forEach(function (f) {
              var li = document.createElement('li');
              var a = document.createElement('a');
              a.href = '#' + f.el.id;
              a.textContent = (f.el.getAttribute('data-th-v2-feld') || '') + ': ' + f.text;
              li.appendChild(a);
              ul.appendChild(li);
            });
          }
          summary.hidden = false;
          summary.focus();
        } else {
          fehler[0].el.focus();
        }
        return;
      }
      if (summary) { summary.hidden = true; }
      gesendet = true;
      laden(qs('[type="submit"]', form), true);
    });
    window.addEventListener('pageshow', function () { gesendet = false; laden(qs('[type="submit"]', form), false); });
  }

  function initKontakt(root) {
    qsa('[data-th-v2-kontakt]', root).forEach(function (k) {
      if (!einmal(k, 'Kontakt')) { return; }
      var wahl = qs('[data-th-v2-kontakt-wahl]', k);
      var tabs = qsa('[data-th-v2-kontakt-tab]', k);
      var panels = qsa('[data-th-v2-kontakt-panel]', k);
      var params = new URLSearchParams(window.location.search);
      var hash = window.location.hash;
      var start = 'kunde';
      if (params.get('thema') === 'b2b' || hash === '#kontakt-b2b') { start = 'b2b'; }

      if (wahl && tabs.length > 1 && panels.length === tabs.length) {
        wahl.hidden = false;
        panels.forEach(function (p) {
          p.setAttribute('role', 'tabpanel');
          p.setAttribute('aria-labelledby', p.getAttribute('data-th-v2-tab-id'));
        });
        var waehle = function (name, fokus) {
          tabs.forEach(function (t) {
            var an = t.getAttribute('data-th-v2-kontakt-tab') === name;
            t.setAttribute('aria-selected', an ? 'true' : 'false');
            t.tabIndex = an ? 0 : -1;
            if (an && fokus) { t.focus(); }
          });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-th-v2-kontakt-panel') !== name; });
        };
        tabs.forEach(function (t, i) {
          t.addEventListener('click', function () { waehle(t.getAttribute('data-th-v2-kontakt-tab'), false); });
          t.addEventListener('keydown', function (ev) {
            var n = null;
            if (ev.key === 'ArrowRight') { n = tabs[(i + 1) % tabs.length]; }
            if (ev.key === 'ArrowLeft') { n = tabs[(i - 1 + tabs.length) % tabs.length]; }
            if (ev.key === 'Home') { n = tabs[0]; }
            if (ev.key === 'End') { n = tabs[tabs.length - 1]; }
            if (n) { ev.preventDefault(); waehle(n.getAttribute('data-th-v2-kontakt-tab'), true); }
          });
        });
        waehle(start, false);
      }

      /* Rücksprung von Shopify (?contact_posted=true#kontakt-…): Erfolg nur im gesendeten Formular, dort ohne Felder */
      if (params.get('contact_posted') === 'true') {
        panels.forEach(function (p) {
          var erfolg = qs('[data-th-v2-erfolg]', p);
          var felder = qs('[data-th-v2-felder]', p);
          if (!erfolg) { return; }
          if (p.getAttribute('data-th-v2-kontakt-panel') === start) {
            if (felder) { felder.hidden = true; }
            window.requestAnimationFrame(function () { erfolg.focus(); });
          } else {
            erfolg.hidden = true;
          }
        });
      }
      qsa('form[data-th-v2-kontakt-form]', k).forEach(initFormular);
    });
  }

  /* ======================================================================
     Suche: Löschen-X im Suchfeld, Zähler der anderen Typen (Section Rendering)
     ====================================================================== */
  function initSuche(root) {
    qsa('[data-th-v2-leeren]', root).forEach(function (btn) {
      if (!einmal(btn, 'Leeren')) { return; }
      var feld = qs(btn.getAttribute('data-th-v2-leeren'));
      if (!feld) { return; }
      var stand = function () { btn.hidden = !feld.value; };
      feld.addEventListener('input', stand);
      btn.addEventListener('click', function () { feld.value = ''; stand(); feld.focus(); });
      stand();
    });
    qsa('[data-th-v2-suche]', root).forEach(function (s) {
      if (!einmal(s, 'Suche')) { return; }
      var sid = s.getAttribute('data-th-v2-section-id');
      if (!sid || !window.fetch || !window.DOMParser) { return; }
      qsa('a[data-th-v2-typ]', s).forEach(function (chip) {
        var zahl = qs('[data-th-v2-zahl]', chip);
        if (!zahl || !zahl.hidden) { return; }
        var url = chip.href + (chip.href.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sid);
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html) { return; }
            var doc = new window.DOMParser().parseFromString(html, 'text/html');
            var el = doc.querySelector('[data-th-v2-treffer]');
            if (!el) { return; }
            var n = parseInt(el.getAttribute('data-th-v2-treffer'), 10);
            if (isNaN(n)) { return; }
            zahl.textContent = zahlDe(n);
            zahl.hidden = false;
            chip.classList.toggle('th-v2s-chip--leer', n === 0);
          })
          .catch(function () { /* Zähler bleibt aus; die Chips funktionieren als Links */ });
      });
    });
  }

  /* ======================================================================
     Warenkorb /cart (Kap. 9): § 356-Pflicht, Paket wechseln, Upgrade, Bump, Gutschein, Entfernen + Rückgängig,
     mobile Kasse-Leiste. Neuaufbau über die Section-Antwort der Cart-API.
     ====================================================================== */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ICON_OK = '<svg class="th-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>';

  function consentEntschieden() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.shouldShowBanner === 'function') {
      try { return !cp.shouldShowBanner(); } catch (e) { return true; }
    }
    return true;
  }

  function initWarenkorb(root) {
    qsa('[data-th-v2-warenkorb]', root).forEach(function (start) {
      var huelle = start.parentNode;
      if (!huelle || !einmal(huelle, 'Korb')) { return; }
      var aktuell = function () { return qs('[data-th-v2-warenkorb]', huelle); };
      var schmal = window.matchMedia ? window.matchMedia('(max-width: 1023px)') : { matches: false };
      var beschaeftigt = false;

      function sectionIds() {
        var ids = [aktuell().getAttribute('data-th-v2-section-id')];
        qsa('cart-items-component[data-section-id]').forEach(function (el) {
          var id = el.getAttribute('data-section-id');
          if (id && ids.indexOf(id) === -1) { ids.push(id); }
        });
        return ids;
      }
      function senden(pfad, body) {
        body.sections = sectionIds().join(',');
        body.sections_url = window.location.pathname + window.location.search;
        return fetch(ROOT + pfad, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok || d.status) { throw new Error(d.description || d.message || 'Warenkorb-Fehler'); }
            return d;
          });
        });
      }
      function korbLaden() {
        return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      }
      function melden(cart, sections) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'th-v2-warenkorb', data: { source: 'th-v2-warenkorb', itemCount: cart.item_count, sections: sections } }
        }));
      }
      function neuAufbauen(daten) {
        var sid = aktuell().getAttribute('data-th-v2-section-id');
        var html = daten && daten.sections ? daten.sections[sid] : null;
        if (!html) { window.location.reload(); return false; }
        var doc = new window.DOMParser().parseFromString(html, 'text/html');
        var neu = doc.querySelector('[data-th-v2-warenkorb]');
        if (!neu) { window.location.reload(); return false; }
        aktuell().replaceWith(neu);
        vorbereiten();
        return true;
      }
      function status(text) { ansagen(qs('[data-th-v2-status]', aktuell()), text); }
      function fehlerStatus() {
        var el = qs('[data-th-v2-status]', aktuell());
        if (el) { el.classList.add('th-v2s-status--fehler'); }
        status('Das hat nicht geklappt. Bitte versuche es erneut oder lade die Seite neu.');
      }
      function fokusZeile(variant) {
        var zeile = qs('[data-th-v2-zeile][data-variant="' + variant + '"]', aktuell());
        var ziel = zeile ? qs('.th-v2s-zeile-titel', zeile) : qs('h1', aktuell());
        if (ziel) { ziel.focus(); }
      }
      function props(el) {
        try { var p = JSON.parse(el.getAttribute('data-props') || '{}'); return p && typeof p === 'object' && !Array.isArray(p) ? p : {}; } catch (e) { return {}; }
      }
      function tauschen(zeileKey, alteProps, neueVariante) {
        var item = { id: Number(neueVariante), quantity: 1 };
        if (Object.keys(alteProps).length) { item.properties = alteProps; }
        return senden('cart/add.js', { items: [item] }).then(function () {
          return senden('cart/change.js', { id: zeileKey, quantity: 0 });
        });
      }

      /* Nur-mit-JS-Bedienelemente einblenden, Kasse-Formular übernimmt die Prüfung selbst */
      function vorbereiten() {
        var w = aktuell();
        qsa('[data-th-v2-paket], [data-th-v2-upgrade-knopf], [data-th-v2-gutschein]', w).forEach(function (el) { el.hidden = false; });
        var kasse = qs('form[data-th-v2-kasse]', w);
        if (kasse) { kasse.noValidate = true; }
        leisteAktualisieren();
      }

      function consentFehler(zeigen) {
        var w = aktuell();
        var box = qs('[data-th-v2-consent-fehler]', w);
        var cb = qs('#cart-consent-checkbox', w);
        var label = cb ? cb.closest('.th-check') : null;
        if (!box || !cb) { return; }
        if (zeigen) {
          box.hidden = false;
          var t = qs('span', box);
          if (t) { ansagen(t, t.textContent); }
          cb.setAttribute('aria-invalid', 'true');
          beschreibung(cb, box.id, true);
          if (label) { label.classList.add('is-invalid'); }
        } else {
          box.hidden = true;
          cb.removeAttribute('aria-invalid');
          beschreibung(cb, box.id, false);
          if (label) { label.classList.remove('is-invalid'); }
        }
      }

      /* Kasse: ohne Haken kein Checkout (Button bleibt aktiv, Fehler + Fokus auf die Checkbox, E18) */
      huelle.addEventListener('submit', function (ev) {
        var form = ev.target;
        if (form.matches('form[data-th-v2-kasse]')) {
          var cb = qs('#cart-consent-checkbox', form);
          if (cb && !cb.checked) {
            ev.preventDefault();
            consentFehler(true);
            try { cb.scrollIntoView({ block: 'center', behavior: reduziert ? 'auto' : 'smooth' }); } catch (e) { /* ältere Browser: focus() scrollt */ }
            cb.focus({ preventScroll: true });
            return;
          }
          laden(ev.submitter || qs('[data-th-v2-kasse-knopf]', form), true);
          return;
        }
        if (form.matches('[data-th-v2-bump-form]')) {
          ev.preventDefault();
          if (beschaeftigt) { return; }
          beschaeftigt = true;
          var btn = qs('[type="submit"]', form);
          laden(btn, true);
          var vid = Number(qs('input[name="id"]', form).value);
          var bumpItem = { id: vid, quantity: 1 };
          /* Line-Item-Properties aus dem Formular übernehmen (z. B. properties[Hinweis] bei befreiten Produkten) */
          qsa('input[name^="properties["]', form).forEach(function (inp) {
            bumpItem.properties = bumpItem.properties || {};
            bumpItem.properties[inp.name.slice(11, -1)] = inp.value;
          });
          var antwort;
          senden('cart/add.js', { items: [bumpItem] })
            .then(function (d) { antwort = d; return korbLaden(); })
            .then(function (cart) {
              if (neuAufbauen(antwort)) { status('Premium-Zugang hinzugefügt.'); fokusZeile(vid); }
              melden(cart, antwort.sections);
            })
            .catch(function () { laden(btn, false); form.submit(); })
            .then(function () { beschaeftigt = false; });
          return;
        }
        if (form.matches('[data-th-v2-gutschein-form]')) {
          ev.preventDefault();
          gutscheinEinloesen(form);
        }
      });

      huelle.addEventListener('change', function (ev) {
        var el = ev.target;
        if (el.id === 'cart-consent-checkbox' && el.checked) { consentFehler(false); }
        if (el.matches('[data-th-v2-paket-select]')) {
          var zeile = el.closest('[data-th-v2-zeile]');
          if (!zeile || beschaeftigt || el.value === zeile.getAttribute('data-variant')) { return; }
          beschaeftigt = true;
          el.disabled = true;
          var neu = el.value;
          var name = el.options[el.selectedIndex] ? el.options[el.selectedIndex].text.split(' · ')[0] : '';
          tauschen(zeile.getAttribute('data-key'), props(zeile), neu)
            .then(function (d) {
              if (neuAufbauen(d)) { status('Paket geändert: ' + name + '.'); fokusZeile(neu); }
              melden(d, d.sections);
            })
            .catch(function () { el.disabled = false; fehlerStatus(); })
            .then(function () { beschaeftigt = false; });
        }
      });

      huelle.addEventListener('click', function (ev) {
        var t = ev.target;
        var w = aktuell();

        var paket = t.closest('[data-th-v2-paket]');
        if (paket) {
          var wahl = document.getElementById(paket.getAttribute('aria-controls'));
          var auf = paket.getAttribute('aria-expanded') !== 'true';
          paket.setAttribute('aria-expanded', auf ? 'true' : 'false');
          if (wahl) {
            wahl.hidden = !auf;
            if (auf) { var sel = qs('select', wahl); if (sel) { sel.focus(); } }
          }
          return;
        }

        var weg = t.closest('[data-th-v2-entfernen]');
        if (weg) {
          var zeile = weg.closest('[data-th-v2-zeile]');
          if (!zeile || !window.fetch) { return; }
          ev.preventDefault();
          if (beschaeftigt) { return; }
          beschaeftigt = true;
          var titel = zeile.getAttribute('data-titel') || 'Position';
          var variant = zeile.getAttribute('data-variant');
          var p = zeile.getAttribute('data-props') || '{}';
          senden('cart/change.js', { id: zeile.getAttribute('data-key'), quantity: 0 })
            .then(function (d) {
              if (neuAufbauen(d)) {
                var ort = qs('[data-th-v2-undo]', aktuell());
                if (ort) {
                  var box = document.createElement('div');
                  box.className = 'th-cart-undo';
                  box.innerHTML = '<span class="th-cart-undo__text">' + ICON_OK + '<span></span></span><button class="th-btn th-btn--link th-btn--sm" type="button" data-th-v2-rueckgaengig>Rückgängig<span class="th-sr-only"></span></button>';
                  qs('.th-cart-undo__text span', box).textContent = '„' + titel + '“ entfernt.';
                  qs('.th-sr-only', box).textContent = ': ' + titel + ' wieder hinzufügen';
                  var knopf = qs('button', box);
                  knopf.setAttribute('data-variant', variant);
                  knopf.setAttribute('data-props', p);
                  knopf.setAttribute('data-titel', titel);
                  ort.appendChild(box);
                  status('„' + titel + '“ entfernt.');
                  knopf.focus();
                }
              }
              melden(d, d.sections);
            })
            .catch(function () { window.location.href = weg.href; })
            .then(function () { beschaeftigt = false; });
          return;
        }

        var zurueck = t.closest('[data-th-v2-rueckgaengig]');
        if (zurueck) {
          if (beschaeftigt) { return; }
          beschaeftigt = true;
          laden(zurueck, true);
          var vId = Number(zurueck.getAttribute('data-variant'));
          var item = { id: vId, quantity: 1 };
          var pr = props(zurueck);
          if (Object.keys(pr).length) { item.properties = pr; }
          var name = zurueck.getAttribute('data-titel') || '';
          var antwort;
          senden('cart/add.js', { items: [item] })
            .then(function (d) { antwort = d; return korbLaden(); })
            .then(function (cart) {
              if (neuAufbauen(antwort)) { status('„' + name + '“ ist wieder im Warenkorb.'); fokusZeile(vId); }
              melden(cart, antwort.sections);
            })
            .catch(function () { laden(zurueck, false); fehlerStatus(); })
            .then(function () { beschaeftigt = false; });
          return;
        }

        var up = t.closest('[data-th-v2-upgrade-knopf]');
        if (up) {
          var karte = up.closest('[data-th-v2-upgrade]');
          if (!karte || beschaeftigt) { return; }
          beschaeftigt = true;
          laden(up, true);
          var ziel = karte.getAttribute('data-variant');
          tauschen(karte.getAttribute('data-key'), props(karte), ziel)
            .then(function (d) {
              if (neuAufbauen(d)) { status('Upgrade übernommen.'); fokusZeile(ziel); }
              melden(d, d.sections);
            })
            .catch(function () { laden(up, false); fehlerStatus(); })
            .then(function () { beschaeftigt = false; });
          return;
        }

        var gAuf = t.closest('[data-th-v2-gutschein-auf]');
        if (gAuf) {
          var gForm = document.getElementById(gAuf.getAttribute('aria-controls'));
          var offen = gAuf.getAttribute('aria-expanded') !== 'true';
          gAuf.setAttribute('aria-expanded', offen ? 'true' : 'false');
          if (gForm) { gForm.hidden = !offen; if (offen) { qs('input', gForm).focus(); } }
          return;
        }

        var gWeg = t.closest('[data-th-v2-gutschein-weg]');
        if (gWeg) {
          if (beschaeftigt) { return; }
          beschaeftigt = true;
          var code = gWeg.getAttribute('data-th-v2-gutschein-weg');
          var rest = qsa('[data-th-v2-gutschein-weg]', w).map(function (b) { return b.getAttribute('data-th-v2-gutschein-weg'); }).filter(function (c) { return c !== code; });
          senden('cart/update.js', { discount: rest.join(',') })
            .then(function (d) {
              if (neuAufbauen(d)) {
                status('Gutschein ' + code + ' entfernt.');
                var tg = qs('[data-th-v2-gutschein-auf]', aktuell());
                if (tg) { tg.focus(); }
              }
              melden(d, d.sections);
            })
            .catch(fehlerStatus)
            .then(function () { beschaeftigt = false; });
        }
      });

      function gutscheinEinloesen(form) {
        var feld = qs('input[name="discount"]', form);
        var fehler = qs('[data-th-v2-gutschein-fehler]', form);
        var code = (feld.value || '').trim();
        var zeigeFehler = function (f, box, text) {
          if (!f || !box) { return; }
          var s = qs('span', box);
          if (s && text) { s.textContent = text; }
          box.hidden = false;
          f.setAttribute('aria-invalid', 'true');
          beschreibung(f, box.id, true);
          f.focus();
        };
        if (!code) { zeigeFehler(feld, fehler, 'Bitte einen Gutscheincode eingeben.'); return; }
        if (beschaeftigt) { return; }
        beschaeftigt = true;
        var btn = qs('[type="submit"]', form);
        laden(btn, true);
        var vorhanden = qsa('[data-th-v2-gutschein-weg]', aktuell()).map(function (b) { return b.getAttribute('data-th-v2-gutschein-weg'); });
        senden('cart/update.js', { discount: vorhanden.concat([code]).join(',') })
          .then(function (d) {
            var treffer = (d.discount_codes || []).filter(function (x) { return String(x.code).toLowerCase() === code.toLowerCase(); })[0];
            if (treffer && treffer.applicable) {
              if (neuAufbauen(d)) { status('Gutschein ' + treffer.code + ' eingelöst.'); }
              melden(d, d.sections);
              return null;
            }
            var gueltig = (d.discount_codes || []).filter(function (x) { return x.applicable; }).map(function (x) { return x.code; });
            return senden('cart/update.js', { discount: gueltig.join(',') }).then(function (d2) {
              if (neuAufbauen(d2)) {
                var w2 = aktuell();
                var tg = qs('[data-th-v2-gutschein-auf]', w2);
                var f2 = qs('[data-th-v2-gutschein-form]', w2);
                if (tg && f2) {
                  tg.setAttribute('aria-expanded', 'true');
                  f2.hidden = false;
                  var feld2 = qs('input[name="discount"]', f2);
                  feld2.value = code;
                  zeigeFehler(feld2, qs('[data-th-v2-gutschein-fehler]', f2), 'Dieser Code ist ungültig.');
                }
              }
              melden(d2, d2.sections);
            });
          })
          .catch(function () { laden(btn, false); zeigeFehler(feld, fehler, 'Das hat nicht geklappt. Bitte versuche es erneut.'); })
          .then(function () { beschaeftigt = false; });
      }

      /* Mobile Kasse-Leiste (Kap. 9 #3): nach der Cookie-Entscheidung (E23), nur solange § 356 und der echte Kasse-Button
         unterhalb des Viewports liegen (E1: ein Coral-Button je Viewport); ab 1024 px aus */
      function leisteAktualisieren() {
        var w = aktuell();
        if (!w) { return; }
        var leiste = qs('[data-th-v2-kassenleiste]', w);
        var anker = qs('[data-th-v2-consent]', w);
        if (!leiste || !anker) { document.documentElement.classList.remove('th-v2s-mit-kassenleiste'); return; }
        var kasse = qs('#checkout', w);
        var h = window.innerHeight;
        var unten = anker.getBoundingClientRect().top > h && (!kasse || kasse.getBoundingClientRect().top > h);
        var zeigen = schmal.matches && consentEntschieden() && unten;
        if (!zeigen && leiste.contains(document.activeElement)) { var cb = qs('#cart-consent-checkbox', w); if (cb) { cb.focus(); } }
        leiste.hidden = !zeigen;
        document.documentElement.classList.toggle('th-v2s-mit-kassenleiste', zeigen);
      }
      var tick = false;
      window.addEventListener('scroll', function () {
        if (tick) { return; }
        tick = true;
        window.requestAnimationFrame(function () { tick = false; leisteAktualisieren(); });
      }, { passive: true });
      window.addEventListener('resize', leisteAktualisieren);
      document.addEventListener('visitorConsentCollected', leisteAktualisieren);
      window.addEventListener('pageshow', function () {
        qsa('[data-th-v2-kasse-knopf]', aktuell()).forEach(function (b) { laden(b, false); });
      });
      vorbereiten();
    });
  }

  function init(root) {
    root = root || document;
    initKontakt(root);
    initSuche(root);
    initWarenkorb(root);
  }

  window.thV2Seiten = { init: init };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); }
  else { init(document); }
  document.addEventListener('shopify:section:load', function (ev) { init(ev.target); });
})(window, document);
